export default () => ({
  all: null,
  current: null,
  slots: null,
  filter: {
    query: '',
    status: 'requested',
  },
  sort: 'date',
  meta: {
    next: null,
    previous: null,
    rowCount: 0,
    total: 0,
  },
});
